<kendo-toolbar
  #kendoToolbar
  [overflow]="overflow"
  [popupSettings]="gridToolbarPopupSettings"
  [size]="'small'"
  [style.width.%]="100"
  [ngClass]="getAlignmentClasses()"
  class="d-flex flex-nowrap"
>
  @if (
    position === 'top' && checkIfMultipleSelectionMode() && showSelectAllButton
  ) {
    <!--            <gk-kendo-toolbar-select-all-checkbox>-->
    <!--            </gk-kendo-toolbar-select-all-checkbox>-->

    <kendo-toolbar-button
      [title]="getToggleLabelText()"
      [attr.aria-label]="getToggleLabelText()"
      [svgIcon]="areAllItemsSelected ? iwIconDeselectAll : iwIconSelectAll"
      (click)="onToggleSelectAllGridItemsClick()"
    >
    </kendo-toolbar-button>
  }
  @for (
    gridToolbarItem of gridToolbarItems | gridToolbarItems: target;
    track i;
    let i = $index
  ) {
    @if (
      getToolbarItemVisibleState(gridToolbarItem.visible) &&
      gridToolbarItem.spacer
    ) {
      @if (deviceService.isMobile() && position === 'bottom') {
        <kendo-toolbar-spacer></kendo-toolbar-spacer>
      }
      @if (!deviceService.isMobile()) {
        <kendo-toolbar-spacer></kendo-toolbar-spacer>
      }
    }
    @switch (gridToolbarItem.type) {
      @case (
        getToolbarItemVisibleState(
          gridToolbarItem.visible,
          gridToolBarButtonType.Dropdown
        )
      ) {
        <kendo-toolbar-dropdownbutton
          [showText]="gridToolbarItem.showText || 'both'"
          [arrowIcon]="true"
          [data]="
            getDropdownItemsTextAndTitleTranslations(gridToolbarItem.data!)
          "
          [title]="getToolbarItemTitle(gridToolbarItem) | translate"
          [text]="getToolbarItemText(gridToolbarItem) | translate"
          [attr.aria-label]="getToolbarItemTitle(gridToolbarItem) | translate"
          [svgIcon]="getSvgIcon(gridToolbarItem)"
          [iconClass]="getIconClass(gridToolbarItem)"
          (itemClick)="handleGridToolbarItemEvent(gridToolbarItem, $event)"
        >
        </kendo-toolbar-dropdownbutton>
      }
      @case (
        getToolbarItemVisibleState(
          gridToolbarItem.visible,
          gridToolBarButtonType.Text
        )
      ) {
        <gk-kendo-toolbar-text
          [title]="getToolbarItemTitle(gridToolbarItem) | translate"
          [attr.aria-label]="getToolbarItemTitle(gridToolbarItem) | translate"
          [text]="getToolbarItemText(gridToolbarItem) | translate"
        >
        </gk-kendo-toolbar-text>
      }

      @case (
        getToolbarItemVisibleState(
          gridToolbarItem.visible,
          gridToolBarButtonType.ButtonWithInput
        )
      ) {
        <gk-kendo-toolbar-button-with-input
          [title]="getToolbarItemTitle(gridToolbarItem) | translate"
          [attr.aria-label]="getToolbarItemTitle(gridToolbarItem) | translate"
          [text]="getToolbarItemTitle(gridToolbarItem) | translate"
          [svgIcon]="getSvgIcon(gridToolbarItem)"
          [inputData]="gridToolbarItem.inputData!"
          (clickEvent)="handleGridToolbarItemEvent(gridToolbarItem, $event)"
        >
        </gk-kendo-toolbar-button-with-input>
      }
      @default {
        @if (getToolbarItemVisibleState(gridToolbarItem.visible)) {
          <kendo-toolbar-button
            [showText]="gridToolbarItem.showText || 'both'"
            [disabled]="getToolbarItemDisabledState(gridToolbarItem)"
            [title]="getToolbarItemTitle(gridToolbarItem) | translate"
            [attr.aria-label]="getToolbarItemTitle(gridToolbarItem) | translate"
            [text]="getToolbarItemText(gridToolbarItem) | translate"
            (click)="
              gridToolbarItem.toggleable ||
                handleGridToolbarItemEvent(gridToolbarItem, $event)
            "
            (selectedChange)="
              handleGridToolbarItemEvent(gridToolbarItem, $event)
            "
            [iconClass]="getIconClass(gridToolbarItem)"
            [svgIcon]="getSvgIcon(gridToolbarItem)"
            [className]="getButtonClass(gridToolbarItem)"
            [themeColor]="getToolbarItemButtonThemeColor(gridToolbarItem)"
            [toggleable]="gridToolbarItem.toggleable!"
            [selected]="getToolbarItemSelectedValue(gridToolbarItem)!"
          >
          </kendo-toolbar-button>
        }
      }
    }
    @if (
      getToolbarItemVisibleState(gridToolbarItem.visible) &&
      gridToolbarItem.separator &&
      !deviceService.isMobile()
    ) {
      <kendo-toolbar-separator></kendo-toolbar-separator>
    }
  }
</kendo-toolbar>
